import { SECTION_PARAM_KEY } from "./sectionParam";

/**
 * Builds the URL that opens a manifest's drawer scrolled to the Documents
 * section (the one-shot `?section=` deep link, see sectionParam.ts).
 *
 * Defensively truncates the currently selected manifest id (and any deeper
 * optional segments after it, e.g. a line-item id) from the path before
 * appending the new id — mirroring useSelectedIdInUrl's truncation — so a
 * chip click can never build a doubled-id path even if one day chips are
 * clickable while the drawer is open.
 */
export function buildManifestDrawerPath(args: {
  pathname: string;
  search: string;
  selectedId: string | undefined;
  manifestId: string;
}): string {
  const { pathname, search, selectedId, manifestId } = args;
  const segments = pathname.split("/").filter(Boolean);
  if (selectedId) {
    const idx = segments.lastIndexOf(selectedId);
    if (idx >= 0) {
      segments.length = idx;
    }
  }
  const params = new URLSearchParams(search);
  params.set(SECTION_PARAM_KEY, "documents");
  return `/${[...segments, manifestId].join("/")}?${params.toString()}`;
}
